import { useLottie } from 'lottie-react'
import React, { ReactElement, useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import useWindowDimensions from 'Root/Shared/utils/useWindowDimensions'

import type { EasySoftwareLottieProps } from './EasySoftwareLottie'

type EasySoftwareLottieClientProps = EasySoftwareLottieProps & {
  placeholder: ReactElement | null
}

function EasySoftwareLottieClient({
  animationData,
  animationDataMobile,
  externalPlaySignal,
  lottieImage,
  placeholder,
}: EasySoftwareLottieClientProps): ReactElement {
  const [isPlaying, setPlaying] = useState(false)
  const [ref, inView] = useInView({
    threshold: 0.6,
    triggerOnce: true,
  })
  const size = useWindowDimensions()
  const lottieAnimation = useLottie({
    animationData:
      size.width < 992 && animationDataMobile
        ? animationDataMobile
        : animationData,
    loop: false,
    autoplay: false,
    rendererSettings: {
      preserveAspectRatio: `xMidYMid slice`,
    },
  })

  useEffect(() => {
    if (externalPlaySignal && inView) {
      lottieAnimation.play()
    }
  }, [externalPlaySignal])

  useEffect(() => {
    if (inView) {
      setPlaying(true)
    }
  }, [inView])

  useEffect(() => {
    if (isPlaying) {
      lottieAnimation.play()
    }
  }, [isPlaying])

  return (
    <>
      {placeholder}
      <div
        ref={ref}
        className={
          `lottie` +
          (size.width < 992 ? ` lottie-mobile` : ` lottie-desktop`) +
          (size.width < 992 &&
          Boolean(lottieImage?.resizePaths?.length) &&
          !animationDataMobile
            ? ` hidden`
            : ``)
        }
      >
        {lottieAnimation.View}
      </div>
    </>
  )
}

export default EasySoftwareLottieClient
